import { render, staticRenderFns } from "./equiposSala.vue?vue&type=template&id=3568e64e&scoped=true&"
import script from "./equiposSala.vue?vue&type=script&lang=js&"
export * from "./equiposSala.vue?vue&type=script&lang=js&"
import style0 from "./equiposSala.vue?vue&type=style&index=0&id=3568e64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568e64e",
  null
  
)

export default component.exports